import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Dashboard from '../pages/dashboard';
import Portfolio from '../pages/dashboard/Portfolio';
import BrandView from '../pages/dashboard/Brand';
import AdminLayout from '../pages/admin';
import AdminLogin from '../pages/admin/Login';
import AdminOverview from '../pages/admin/pages/Overview';
import AdminProjects from '../pages/admin/pages/Projects';
import AdminHeroImage from '../pages/admin/pages/HeroImage';
import AdminAboutImages from '../pages/admin/pages/AboutImages';
import AdminCv from '../pages/admin/pages/Cv';
import NotFound from '../components/atoms/NotFound';
import { SiteDataProvider } from '../context/SiteDataContext';
import { ThemeProvider } from '../context/ThemeContext';
import useDocumentMeta from '../hooks/useDocumentMeta';

const RouteMeta: React.FC = () => {
    const location = useLocation();

    useDocumentMeta(location.pathname);

    return null;
};

const AppRouter: React.FC = () => {
    return (
        <Router>
            <RouteMeta />
            <ThemeProvider>
            <SiteDataProvider>
                <Routes>
                    <Route path='/' element={<Navigate to='/portfolio' replace />} />
                    <Route path='/main' element={<Navigate to='/portfolio' replace />} />
                    <Route path='/main/home' element={<Navigate to='/portfolio' replace />} />
                    <Route element={<Dashboard />}>
                        <Route path='/portfolio' element={<Portfolio />} />
                        <Route path='/brand' element={<BrandView />} />
                    </Route>
                    <Route path='/dashboard/login' element={<AdminLogin />} />
                    <Route path='/dashboard' element={<AdminLayout />}>
                        <Route index element={<Navigate to='/dashboard/overview' replace />} />
                        <Route path='overview' element={<AdminOverview />} />
                        <Route path='projects' element={<AdminProjects />} />
                        <Route path='hero' element={<AdminHeroImage />} />
                        <Route path='about' element={<AdminAboutImages />} />
                        <Route path='cv' element={<AdminCv />} />
                    </Route>
                    <Route path='*' element={<NotFound />} />
                </Routes>
            </SiteDataProvider>
            </ThemeProvider>
        </Router>
    );
};

export default AppRouter;
